import { JSX, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MeCallRevised } from "../components/Common/ProfileDetails/MeCallRevised";
import { NAVIGATION_CONST } from "../assets/constants/constants";

const PublicRoute = ({ children }: { children: JSX.Element }) => {
    const token = localStorage.getItem("access_token");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const activeLoginTypes = useSelector((state: any) => state?.items?.storeActiveLoginType)
    let login_type = activeLoginTypes?.loginType;
    let account_type = activeLoginTypes?.account_type;
    const calledRef = useRef(false);

    useEffect(() => {
        if (!token || calledRef.current) return;

        calledRef.current = true;

        MeCallRevised({
            navigate,
            dispatch,
            login_type,
            account_type,
            coming_from: NAVIGATION_CONST.LOGIN,
        });
    }, [token, dispatch, navigate, login_type, account_type]);

    // Show login page only if no token
    if (!token) return children;

    // Token exists → MeCallRevised will navigate
    return null;
};

export default PublicRoute;
